export const PROTECTED_PAGE_ACCESS_PENDING = "pending";
export const PROTECTED_PAGE_ACCESS_ALLOWED = "allowed";
export const PROTECTED_PAGE_ACCESS_DENIED = "denied";

export const resolveProtectedPageAccessState = ({
  accessState,
  permissionDenied = false,
}) => {
  if (accessState === PROTECTED_PAGE_ACCESS_PENDING) {
    return PROTECTED_PAGE_ACCESS_PENDING;
  }

  if (permissionDenied || accessState === PROTECTED_PAGE_ACCESS_DENIED) {
    return PROTECTED_PAGE_ACCESS_DENIED;
  }

  return PROTECTED_PAGE_ACCESS_ALLOWED;
};
